module.exports = __webpack_public_path__ + "static/img/how-to-join-step-2.89160f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fifa2026/images/how-to-join-step-2.png
// module id = /2+G
// module chunks = 1